import React, { ReactElement } from 'react';
import Icon from '@components/Icon';
import { WalletType } from '@types';

interface WalletIconProps {
  className?: string;
  variant: WalletType;
  idPrefix?: string;
}

const WalletIcon = ({
  className,
  variant,
  idPrefix = '',
}: WalletIconProps): ReactElement => {
  switch (variant) {
    case WalletType.metamask:
      return (
        <Icon.Metamask
          className={className}
          data-testid={WalletType.metamask}
        />
      );
    case WalletType.keplr:
      return (
        <Icon.Keplr
          idPrefix={idPrefix}
          className={className}
          data-testid={WalletType.keplr}
        />
      );
    case WalletType.deficonnect:
      return (
        <Icon.CryptoCom
          className={className}
          data-testid={WalletType.deficonnect}
        />
      );
    default:
      return (
        <Icon.CryptoCom
          className={className}
          data-testid={WalletType.deficonnect}
        />
      );
  }
};

export default WalletIcon;
